import { apiGet, apiPost, type ApiResponse } from './genesisApi/httpsMethods';

export interface LlmModel {
  id: number;
  provider: string;
  model_name: string;
  created_at: string;
  updated_at: string;
  updated_by: string | null;
}

export interface UpsertLlmModelRequest {
  provider: string;
  model_name: string;
}

export async function getLlmModels(): Promise<ApiResponse<LlmModel[]>> {
  return apiGet<LlmModel[]>('api/llm-models');
}

export async function saveLlmModel(data: UpsertLlmModelRequest): Promise<ApiResponse<LlmModel>> {
  return apiPost<LlmModel>('api/llm-models', data);
}

